import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccessPolicyService } from '../services/access-policy.service';

export function permittedLandingPath(accessPolicy: AccessPolicyService): string {
  if (accessPolicy.isSuperAdmin()) return '/system';
  if (accessPolicy.canAccessDashboard()) return '/dashboard';
  if (accessPolicy.canReadSalesInvoices()) return '/invoices';
  if (accessPolicy.canManageSalesInvoiceDrafts()) return '/invoices';
  if (accessPolicy.canManageQuotes()) return '/quotes';
  if (accessPolicy.canReadQuotes()) return '/quotes';
  if (accessPolicy.canReadBills()) return '/bills';
  return '/profile';
}

export const dashboardAccessGuard: CanActivateFn = () => {
  const accessPolicy = inject(AccessPolicyService);
  const router = inject(Router);

  return accessPolicy.canAccessDashboard()
    ? true
    : router.createUrlTree([permittedLandingPath(accessPolicy)]);
};
